


  
  

  var faAlberta = {
    prefix: 'fak',
    iconName: 'alberta',
    icon: [
      512,
      512,
      [],
      'e001',
      
      'm124.3 2.8h266.3l-.5 506.3H283.6c-27.3-59.5-67.6-113.8-120.7-162.5l-10.9-8.1-27.2-31-.3-3c-3.9-70.7-4-171.6-.2-301.7z'
      
    ]
  };

  

  
  

  var faQuebec = {
    prefix: 'fak',
    iconName: 'quebec',
    icon: [
      512,
      512,
      [],
      'e000',
      
      'm206.2 509.2h-52.3l-17.9-13.9-18.4-2.4-8.8-1-7.2-3.8-46.1-35-6.1-14.2 1.8-18.7 10.4-75.3 18.1-38.4 5.4-13.6-2.7-60.8 10.6-13.1 23.8-8.6 15.8-15.2 8-37.4-20.2-36.9-3.8-6.7 2.2-7.4 16.8-38.7-.5-51.7 3-10.2 10.2-3.2 4.2 1.8 19 8.6 25.4-.5 8.3 .6 5.1 6.1 15.2 22.7 16.3 11 5.8 5.3 .5 7.7 3.4 40 28.8 22.2 .3 .2 12.6-.8 8.5-9.6 11.2-33.7 5.9-9.6 4.3 10.2 24.3 138.2-9.3 10.9-1.6-.2-25.6-5.1-22.4 5.9-8.6 21.4h0l1.4 6.9 16 29.4 27.4 25.3 8.8 2.2 6.4-6.6 5.3-11.4 3-3 4 1.8 3.4 3.4 7 4.5 7.8 .6 87.3-11.2h1.1l3.5 6.4-17.3 27.8-22.6 18.4-55 9.1-10.2 1.3 6.2 8.2 20.3 16.2 1.9 2.4-6.4 9.4-12.2-3-13.1-14.6-.8-1.4-19.5-15-24.3 3.8-44 34.1-48.9 58.4-.3 1.4 1.1 1.4 4.2 2.2 1.6-1.4 65.7-56.5 28.3-11.4 25.4 1.6 6.1 5.1 .5 13.9-12.2 7-52.6 9.3-42.1 26.2-5.4 6.4-3.7 7.5-12.5 23-14.7 13.8z'
      
    ]
  };

  



export {

  faAlberta,
  

  faQuebec,
  

};
